/**
 * Map a physical `text-align` value to a CSS logical one so an authored
 * left/right mirrors under RTL while center/justify stay direction-neutral:
 *
 *   left  → start   (left in LTR, right in RTL)
 *   right → end      (right in LTR, left in RTL)
 *   center / justify → unchanged
 *
 * Relies on the element inheriting the correct `dir` (set on <html> and on the
 * TipTap `EditorContent`), so the browser resolves `start`/`end` per direction
 * and no explicit RTL flag is needed. Returns null for an unset value.
 */
export function toLogicalTextAlign(value: string | null | undefined): string | null {
  if (!value) return null
  if (value === 'left') return 'start'
  if (value === 'right') return 'end'
  return value
}
